const IMAGE_BUCKET = "Images";
const DOCUMENTS_BUCKET = "inkriv";
const AI_AGENT_API = import.meta.env.VITE_APP_AI_AGENT_API;
const CLOUDFLARE_SITEKEY = import.meta.env.VITE_APP_CLOUDFLARE_SITEKEY;
const SERVER_API = import.meta.env.VITE_APP_SERVER_API + "/api";
const SERVER_API_PUBLIC = import.meta.env.VITE_APP_SERVER_API;

const HASH = import.meta.env.VITE_APP_RANDOM_HEX;

const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
];

export {
  IMAGE_BUCKET,
  DOCUMENTS_BUCKET,
  AI_AGENT_API,
  CLOUDFLARE_SITEKEY,
  SERVER_API,
  ALLOWED_FILE_TYPES,
  HASH,
  SERVER_API_PUBLIC,
};
